import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'homePageController';
export default {
    /**
     * 获取当日新增案件
     */
    getTodayInsertCaseCount: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getTodayInsertCaseCount',
        type: requestType.Get
    },
    /**
     * 催收案件数量统计
     */
    getCollectionCaseCount: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getCollectionCaseCount',
        type: requestType.Get
    },
    /**
     * 流出案件数量统计
     */
    getOutCaseCount: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getOutCaseCount',
        type: requestType.Get
    },
    /**
     * 行动代码监控
     */
    actionCodeMonitor: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'actionCodeMonitor',
        type: requestType.Get
    },
    /*
     * 获取催收员案件量
     */
    getHomeCaseTotal: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getHomeCaseTotal',
        type: requestType.Get
    },
    /**
     * 催收员回款排行榜
     */
    getCollectorRackIngData: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getCollectorRackIngData',
        type: requestType.Get
    },
    /**
     * 案件总数
     */
    getAllCaseCount: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getAllCaseCount',
        type: requestType.Get
    },
    /**
     * 车库车辆
     */
    getAllWarehouseCar: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getAllWarehouseCar',
        type: requestType.Get
    },
    /**
     * 排名
     */
    getCollectionRanking: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getCollectionRanking',
        type: requestType.Get
    },
    /**
     * 待催收案件
     */
    getWaitCollectCaseChart: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getWaitCollectCaseChart',
        type: requestType.Get
    },
    /**
     * 流出案件
     */
    getOutCaseChart: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getOutCaseChart',
        type: requestType.Get
    },
    /**
     * 回款统计
     */
    getRepaymentChart: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getRepaymentChart',
        type: requestType.Get
    }
};
